import * as Utils from "utils/utils";
import * as LoginConstants from "routes/login/constants";
import * as React from "react";
import PropTypes from "prop-types";
import * as FetchConstants from "hooks/use-fetch/constants";
import useFetch from "hooks/use-fetch";
import Loader from "components/loader";

const Login = () => {
    const token = Utils.getQueryParam(LoginConstants.QUERY_PARAMETERS.TOKEN);
    const nextUrl = Utils.getQueryParam(LoginConstants.QUERY_PARAMETERS.NEXT_URL);

    if (token) {
        return (
            <Authenticator token={token} nextUrl={nextUrl} />
        );
    }
    else {
        console.log("No token present.");
        window.location.href = `${document.referrer}?ssoError=1`;
    }
};

const Authenticator = ({ token, nextUrl }) => {
    // Without memoizing this value, useFetch gets called over and over again
    const url = React.useMemo(() => ("api/Authentication/SetCookie"), []);

    // Without memoizing this value, useFetch gets called over and over again
    const options = React.useMemo(() => ({
        method: FetchConstants.HTTP_METHOD.POST,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: token })
    }), [token]);

    const { loading, error } = useFetch(url, options);
    
    if (loading) {
        return (
            <Loader />
        );
    }
    else if (error) {
        window.location.href = `${document.referrer}?ssoError=1`;
    }
    else {
        window.location.href = nextUrl ?? document.referrer;
    }
};

Authenticator.propTypes = {
    token: PropTypes.string.isRequired,
};

export default Login;